import React, { useState } from 'react';
import classNames from 'classnames';
// @ts-ignore
import VideoThumbnail from 'react-video-thumbnail';

import { File } from '../../../types';
import { getFileUrl, getThumbnail } from '../../../utils';

interface Props {
  video: File;
  onClick: () => void;
  isPortrait: boolean;
}

const VideoBlock: React.FC<Props> = (props) => {
  const { video, onClick, isPortrait } = props;

  const [thumbnailImg, setThumbnailImg] = useState(null);

  return (
    <div
      key={video.elementId ?? video.uid}
      className={classNames({
        'w-[calc((100%_-_1rem)_/_2)] sm:w-[calc((100%_-_(1rem_*_2))_/_3)]':
          !isPortrait,
        'w-[calc((100%_-_(1rem_*_3))_/_4)] sm:w-[calc((100%_-_(1rem_*_4))_/_5)]':
          isPortrait,
      })}
    >
      <div
        className={classNames({
          'relative w-full rounded-md cursor-pointer transition-all hover:scale-110': true,
          'aspect-video': !isPortrait,
          'aspect-[9/16]': isPortrait,
        })}
        onClick={onClick}
      >
        <img
          src={thumbnailImg ?? getThumbnail(video.frameId)}
          className="w-full h-full object-cover rounded-md"
          alt="Video Thumbnail"
        />

        {!video.frameId && (
          <VideoThumbnail
            videoUrl={getFileUrl(video.elementId, video.name)}
            thumbnailHandler={(thumbnail: any) => setThumbnailImg(thumbnail)}
            renderThumbnail={false}
          />
        )}
      </div>

      <div className="text-xs mt-1 leading-none break-words">{video.name}</div>
    </div>
  );
};

export default VideoBlock;
